import { ocOffersWidgetScript } from '~/constants/scripts';

export const handle = {
	scripts: () => [ocOffersWidgetScript],
};
